import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AppHubService as AppHubV4Service } from '../../../services/appHubV4Service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-capability-recommendations-popup',
  standalone: false,
  templateUrl: './capability-recommendations-popup.component.html',
  styleUrls: ['./capability-recommendations-popup.component.css']
})
export class CapabilityRecommendationsPopupComponent implements OnInit {
  @Input() selectedApp: any;
  @Input() capabilityRecommendations: any[] = [];
  @Input() capListForApp: any[] = [];
  @Input() hideApplyButton: boolean = false;
  @Input() openRequestCapabilities: any[] = [];
  @Input() isEditAccess: boolean = false;
  @ViewChild('editableTableComponent') editableTableComponent: any;
  _selectedEditableTable: any;
  @ViewChild('selectedEditableTable') set selectedEditableTable(table: any) {
    this._selectedEditableTable = table;
    if (table) {
      setTimeout(() => {
        this.selectedDataSource.data.forEach(item => {
          if (item._orgRows?.some(r => r.org_id) && !table.selection.isSelected(item)) {
            table.selection.select(item);
          }
        });
      });
    }
  }
  @ViewChild('capPopUpRef') capPopUpRef: any;
  @ViewChild('applyPopup') applyPopup: any;
  _nonRecSelectedEditableTable: any;
  @ViewChild('nonRecSelectedEditableTable') set nonRecSelectedEditableTable(table: any) {
    this._nonRecSelectedEditableTable = table;
    if (table) {
      setTimeout(() => {
        this.nonRecTableDataSource.data.forEach(item => {
          if (item._orgRows?.some((r: any) => r.org_id) && !table.selection.isSelected(item)) {
            table.selection.select(item);
          }
        });
      });
    }
  }
  recCapabilitiesExpanded: boolean = true;
  nonRecCapabilitiesExpanded: boolean = false;
  activeOrgRow: any = null;
  isSelectedView: boolean = false;
  selectedItems: any[] = [];
  orgTab: boolean = false;
  selectedOrgData: any = null;
  nonRecommendedCapabilities: boolean = false;
  nonRecRows: any[] = [];
  rowCapabilitySelections: boolean[] = [];
  nonRecTableDataSource = new MatTableDataSource([]);
  nonRecSelectedItems: any[] = [];
  nonRecFeedback: string = '';
  nonRecTableColumns = [
    { columnDef: 'select',      header: '',            width: '5%',  paddingLeft: '1% !important', cell: () => '' },
    { columnDef: 'group_model', header: 'Group Model', width: '25%', cell: (e: any) => e?.group_model ?? '' },
    { columnDef: 'capability',  header: 'Capability',  width: '30%', cell: (e: any) => e?.capability ?? '' },
    { columnDef: 'primarySet',  header: 'Primary',     width: '20%', cellStyle: () => ({}), cell: (e: any) => e ? `${e.primary_status}` : '' },
    { columnDef: 'actions',     header: 'Actions',     width: '20%', cell: () => '' }
  ];
  nonRecTableConfig: any = { pageSizes: 0, serverSidePagination: false, isPaginatorAttached: false, pageSize: 1 };
  nonRecEditSchemaConfig = { primarySet: 'primarySet', actions: 'actions' };
  nonRecCapNodeItems: string[] = [];
  extraMappedCapsPerRow: string[][] = [];
  combinedCapList: any[] = [];
  private _recHasOpenRequest: boolean = false;
  private _recWqList: any[] = [];
  private _nonRecHasOpenRequest: boolean = false;
  private _nonRecWqList: any[] = [];
  @Output() openRequestChange = new EventEmitter<any[]>();

  get canAddMore(): boolean {
    return this.nonRecRows.length > 0 && this.rowCapabilitySelections.every(v => v);
  }

  get canContinue(): boolean {
    if (this._recHasOpenRequest || this._nonRecHasOpenRequest) return false;
    return this.selectedItems.length > 0 || this.rowCapabilitySelections.some(v => v);
  }

  get continueDisabledTooltip(): string {
    return (this._recHasOpenRequest || this._nonRecHasOpenRequest) ? 'Please scroll up for reason' : 'Please select atleast one capability to continue';
  }

  onRowCapabilitySelected(index: number, data: any): void {
    if (!data) {
      // Checkbox unchecked: mark row excluded but keep capability so dropdown still shows selection
      this.rowCapabilitySelections[index] = false;
      this.nonRecRows[index]._orgRows = [];
      this.nonRecRows[index]._addOrgCount = 0;
      this.nonRecRows[index].capPopUpVisible = false;
      this.nonRecRows[index].expand = false;
      this.nonRecCapNodeItems[index] = '';
      this.recomputeExtraMappedCaps();
      this._checkNonRecOpenRequests();
      return;
    }
    this.rowCapabilitySelections[index] = true;
    this.nonRecCapNodeItems[index] = data.capabilityNodeItem || data.capability || '';
    this.recomputeExtraMappedCaps();
    // Mutate the existing row object in place to preserve the component instance's state
    Object.assign(this.nonRecRows[index], data);
    this._checkNonRecOpenRequests();
  }
  selectedDataSource = new MatTableDataSource([]);
  selectedColumns = [
    { columnDef: 'select', header: '', width: '5%', paddingLeft: '1% !important', cell: () => `` },
    {
      columnDef: 'group_model',
      header: 'Group Model',
      width: '20%',
      cell: (element: any) => element ? `${element.group_model}` : ''
    },
    {
      columnDef: 'capability',
      header: 'Capability',
      width: '30%',
      cell: (element: any) => element ? `${element.capability}` : ''
    },
    {
      columnDef: 'score',
      header: 'Score',
      width: '15%',
      cell: (element: any) => element?.score != null ? `${parseFloat(element.score).toFixed(1)}%` : ''
    },
    {
      columnDef: 'primarySet',
      header: 'Primary',
      width: '15%',
      cellStyle: () => ({}),
      cell: (element: any) => element ? `${element.primary_status}` : ''
    },
    {
      columnDef: 'actions',
      header: 'Actions',
      width: '20%',
      cell: () => ''
    }
  ];
  editSchemaConfig = { primarySet: 'primarySet', actions: 'actions' };
  dataSource = new MatTableDataSource([]);

  columns = [
    { columnDef: 'select', header: '', width: '5%', paddingLeft: '1% !important', cell: () => `` },
    {
      columnDef: 'group_model',
      header: 'Group Model',
      width: '20%',
      customHeaderStyle: { 'font-style': 'italic' },
      cell: (element: any) => element ? `${element.group_model}` : ''
    },
    {
      columnDef: 'capability',
      header: 'Capability',
      width: '30%',
      cell: (element: any) => element ? `${element.capability}` : ''
    },
    {
      columnDef: 'score',
      header: 'Score',
      width: '20%',
      cell: (element: any) => element?.score != null ? `${parseFloat(element.score).toFixed(1)}%` : ''
    },
    {
      columnDef: 'primarySet',
      header: 'Primary',
      width: '20%',
      cellStyle: () => ({}),
      cell: (element: any) => element ? `${element.primary_status}` : ''
    }
  ];

  tableConfig: any = {
    pageSizes: 0,
    serverSidePagination: false,
    isPaginatorAttached: false,
    pageSize: this.dataSource.data.length
  };

  selectedTableConfig: any = {
    pageSizes: 0,
    serverSidePagination: false,
    isPaginatorAttached: false,
    pageSize: 1
  };

  constructor(private AppHubV4Service: AppHubV4Service, public toaster: ToastrService,) {}

  private _checkNonRecOpenRequests(): void {
    const matchedCapNames = this.rowCapabilitySelections.reduce<string[]>((acc, selected, i) => {
      if (!selected) return acc;
      const capName = (this.nonRecRows[i]?.capability || '').trim().toLowerCase();
      if (capName && this.openRequestCapabilities.some(
        o => (o.selectedCapability || '').trim().toLowerCase() === capName
      )) {
        acc.push(capName);
      }
      return acc;
    }, []);
    if (matchedCapNames.length > 0) {
      this._nonRecWqList = this.openRequestCapabilities.filter(
        o => matchedCapNames.includes((o.selectedCapability || '').trim().toLowerCase())
      );
      this._nonRecHasOpenRequest = true;
    } else {
      this._nonRecHasOpenRequest = false;
      this._nonRecWqList = [];
    }
    this._emitOpenRequest();
  }

  private _emitOpenRequest(): void {
    if (this._recHasOpenRequest) {
      this.openRequestChange.emit(this._recWqList);
    } else if (this._nonRecHasOpenRequest) {
      this.openRequestChange.emit(this._nonRecWqList);
    } else {
      this.openRequestChange.emit([]);
    }
  }

  ngOnInit() {
    if (this.capabilityRecommendations?.length) {
      const mapped = this.capabilityRecommendations.map(item => {
        const rec = item.Recommendation ?? {};
        const level = item.Recommendation_Type?.split('_')[0] ?? '';
        const capName = rec[`capability${level}`] ?? '';
        const capNameLower = capName.trim().toLowerCase();
        return {
          ...rec,
          capability: capName,
          score: item.cosin_Similarity_Score ? parseFloat(item.cosin_Similarity_Score) : '',
          primary_status: 'Yes',
          orgdatasource: new MatTableDataSource([]),
          alreadyMapped: this.capListForApp.some(c => c.capability?.trim().toLowerCase() === capNameLower)
        };
      });
      this.dataSource = new MatTableDataSource(mapped);
    }
    this.combinedCapList = [...this.capListForApp, ...this.dataSource.data];
    this.tableConfig = { ...this.tableConfig, pageSize: this.dataSource.data.length };
  }

  @Input() set applyTrigger(val: number) {
    if (val > 0) this.onApply();
  }
  @Output() applyConfirmed = new EventEmitter<string | null>();
  @Output() addCapability = new EventEmitter<any[]>();
  @Output() closePopup = new EventEmitter<void>();
  @Output() orgTabChange = new EventEmitter<boolean>();
  @Output() orgSelectionChange = new EventEmitter<any[]>();

  private getSelectedCapOrgData(): any[] {
    const recSelected: any[] = this._selectedEditableTable?.selection?.selected || [];
    const nonRecSelected: any[] = this._nonRecSelectedEditableTable?.selection?.selected || [];
    const recSet = new Set(recSelected);
    return [...recSelected, ...nonRecSelected].flatMap((cap: any) => {
      const isRecommended = recSet.has(cap) ? 'Yes' : 'No';
      return (cap._orgRows || [])
        .filter((r: any) => r.org_id)
        .map((org: any) => ({
          ...org,
          capInfo: { ...cap, similarityScore: cap.score ?? null, isRecommended }
        }));
    });
  }


  checkboxClick(event: any) {
    const newSelected: any[] = (event && event.data && event.data.length > 0) ? [...event.data] : [];
    // Clear org data for items that were deselected so re-checking starts fresh
    this.selectedItems.forEach(item => {
      if (!newSelected.includes(item)) {
        item._orgRows = [];
        item._addOrgCount = 0;
        item.capPopUpVisible = false;
        item.expand = false;
      }
    });
    this.selectedItems = newSelected;
    this.updateOpenRequestAtTopFromSelection();
  }

  refreshOpenRequestList(_event: any): void {
    console.log('refreshOpenRequestList triggered with event:', _event);
  }

  updateOpenRequestAtTopFromSelection(): void {
    const matchedCapNames = this.selectedItems.reduce<string[]>((acc, item) => {
      const capName = (item.capability || '').trim().toLowerCase();
      if (capName && this.openRequestCapabilities.some(
        o => (o.selectedCapability || '').trim().toLowerCase() === capName
      )) {
        acc.push(capName);
      }
      return acc;
    }, []);
    if (matchedCapNames.length > 0) {
      this._recWqList = this.openRequestCapabilities.filter(
        o => matchedCapNames.includes((o.selectedCapability || '').trim().toLowerCase())
      );
      this._recHasOpenRequest = true;
    } else {
      this._recHasOpenRequest = false;
      this._recWqList = [];
    }
    this._emitOpenRequest();
  }

  nonRecCheckboxClick(event: any) {
    this.nonRecSelectedItems = [];
    console.log("event",event);
    
    if (event && event.data && event.data.length > 0) {
      this.nonRecSelectedItems = [...event.data];
    }
  }

  private readonly defaultWidths: Record<string, string> = {
    select: '5%', group_model: '20%', capability: '30%', score: '20%', primarySet: '20%'
  };

  private readonly selectedWidths: Record<string, string> = {
    select: '4%', group_model: '17%', capability: '25%', score: '15%', primarySet: '15%', actions: '20%'
  };

  onCapabilitySelected() {
    this.orgTab = true;
    this.orgTabChange.emit(true);
    const selected = this.editableTableComponent?.getSelectedRow() || [];
    this.selectedDataSource = new MatTableDataSource([...selected]);
    if (selected.length > 0) {
      this.isSelectedView = true;
      selected.forEach((item: any) => {
        const hasRows = (item._orgRows?.length || 0) > 0;
        item.capPopUpVisible = hasRows;
        item.expand = hasRows;
      });
      this.selectedTableConfig = { ...this.selectedTableConfig, pageSize: selected.length };
      this.columns = [
        ...this.columns.map(c => ({ ...c, width: this.selectedWidths[c.columnDef] || c.width })),
        { columnDef: 'actions', header: 'Actions', width: this.selectedWidths['actions'], cellStyle: () => ({}), cell: () => '' }
      ];
    }
    const nonRecSelected = this.nonRecRows.filter((r, i) => this.rowCapabilitySelections[i] && r?.capability);
    this.nonRecTableDataSource = new MatTableDataSource(nonRecSelected);
    if (nonRecSelected.length > 0) {
      this.isSelectedView = true;
      nonRecSelected.forEach((item: any) => {
        const hasRows = (item._orgRows?.length || 0) > 0;
        item.capPopUpVisible = hasRows;
        item.expand = hasRows;
        item._addOrgCount = item._addOrgCount || 0;
      });
      this.nonRecTableConfig = { ...this.nonRecTableConfig, pageSize: nonRecSelected.length };
    }
  }

  onBack() {
    this.orgTab = false;
    this.orgTabChange.emit(false);
    this.isSelectedView = false;
    this.selectedDataSource.data.forEach((item: any) => {
      item.capPopUpVisible = false;
      item.expand = false;
      item._addOrgCount = 0;
    });
    this.columns = this.columns
      .filter(c => c.columnDef !== 'actions')
      .map(c => ({ ...c, width: this.defaultWidths[c.columnDef] || c.width }));
  }

  onAddOrganization(element: any) {
    element.expand = true;
    element.capPopUpVisible = true;
    element._addOrgCount = (element._addOrgCount || 0) + 1;
  }

  onOrgRemoved(item: any) {
    const hasRows = (item._orgRows?.length || 0) > 0;
    const hasOrgs = item._orgRows?.some((r: any) => r.org_id);
    if (!hasRows) {
      item.expand = false;
    }
    const isNonRec = this.nonRecTableDataSource.data.includes(item);
    const tableRef = isNonRec ? this._nonRecSelectedEditableTable : this._selectedEditableTable;
    if (!hasOrgs && tableRef?.selection.isSelected(item)) {
      tableRef.selection.deselect(item);
    }
    const anyOrgExists =
      this.selectedDataSource.data.some((cap: any) => cap._orgRows?.some((r: any) => r.org_id)) ||
      this.nonRecTableDataSource.data.some((cap: any) => cap._orgRows?.some((r: any) => r.org_id));
    if (!anyOrgExists) {
      this.selectedOrgData = null;
    }
    this.orgSelectionChange.emit(this.getSelectedCapOrgData());
  }

  onOrgSelected(item: any) {
    this.selectedOrgData = { ...item };
    const isNonRec = this.nonRecTableDataSource.data.includes(item);
    const tableRef = isNonRec ? this._nonRecSelectedEditableTable : this._selectedEditableTable;
    if (tableRef && !tableRef.selection.isSelected(item)) {
      tableRef.selection.select(item);
    }
    this.orgSelectionChange.emit(this.getSelectedCapOrgData());
  }

  onApply() {
    this.applyPopup.show();
  }

  onNonRecommended() {
    if (this.nonRecommendedCapabilities) return;
    this.nonRecommendedCapabilities = true;
    this.nonRecCapabilitiesExpanded = true;
    this.nonRecRows.push({});
    this.rowCapabilitySelections.push(false);
    this.nonRecCapNodeItems.push('');
    this.recomputeExtraMappedCaps();
  }

  onAddMoreCapabilities(){
    this.nonRecRows.push({});
    this.rowCapabilitySelections.push(false);
    this.nonRecCapNodeItems.push('');
    this.recomputeExtraMappedCaps();
  }

  trackByIndex(index: number): number {
    return index;
  }

  getDisabledTooltipFn = (item: string): string => {
    const normalised = item.trim().toLowerCase();
    const isInAIRecommendations = this.dataSource.data.some(
      (cap: any) => (cap.capability || '').trim().toLowerCase() === normalised
    );
    if (isInAIRecommendations) {
      return 'This capability is already present in AI recommendations.';
    }
    return 'This capability is already selected.';
  }

  private recomputeExtraMappedCaps(): void {
    this.extraMappedCapsPerRow = this.nonRecRows.map((_, i) =>
      this.nonRecCapNodeItems.filter((item, j) => j !== i && !!item)
    );
  }

  get selectedOrgCount(): number {
    const recSelected: any[] = this._selectedEditableTable?.selection?.selected || [];
    const nonRecSelected: any[] = this._nonRecSelectedEditableTable?.selection?.selected || [];
    return [...recSelected, ...nonRecSelected]
      .reduce((sum: number, cap: any) => sum + (cap._orgRows?.filter((r: any) => r.org_id)?.length || 0), 0);
  }

  get checkedCapabilitiesCount(): number {
    return (this._selectedEditableTable?.selection?.selected?.length || 0) +
      (this._nonRecSelectedEditableTable?.selection?.selected?.length || 0);
  }

  onSubmit() {
    if (this.hideApplyButton) {
      this.applyConfirmed.emit(this.nonRecFeedback?.trim() || null);
      this.applyPopup.hide();
      return;
    }
    const recSelected: any[] = this._selectedEditableTable?.selection?.selected || [];
    const nonRecSelected: any[] = this._nonRecSelectedEditableTable?.selection?.selected || [];
    const buildEntries = (caps: any[], isRecommended: 'Yes' | 'No', reason: string | null) =>
      caps.flatMap((cap: any) =>
        (cap._orgRows || [])
          .filter((r: any) => r.org_id)
          .map((org: any) => ({
            ...org,
            capability: cap.capability ?? null,
            capabilityL0: cap.capabilityL0 ?? null,
            capabilityL1: cap.capabilityL1 ?? null,
            capabilityL2: cap.capabilityL2 ?? null,
            capabilityL3: cap.capabilityL3 ?? null,
            capabilityL0Id: cap.capabilityL0Id ?? null,
            capabilityL1Id: cap.capabilityL1Id ?? null,
            capabilityL2Id: cap.capabilityL2Id ?? null,
            capabilityL3Id: cap.capabilityL3Id ?? null,
            org_id: org.org_id,
            app_id: this.selectedApp?.app_id,
            app_name: this.selectedApp?.app_name,
            group_model: cap.group_model,
            primary_status: cap.primary_status,
            similarityScore: cap.score != null ? parseFloat(cap.score.toFixed(1)) : null,
            isRecommended,
            reason,
            createdById: sessionStorage.getItem('MsId'),
            createdByName: JSON.parse(sessionStorage.getItem('currentUser')),
            createdAt: new Date().toISOString(),
            updatedColumns: 'Add Capability'
          }))
      );

    const addPayload = [
      ...buildEntries(recSelected, 'Yes', null),
      ...buildEntries(nonRecSelected, 'No', this.nonRecFeedback?.trim() || null)
    ];

    console.log('Selected capabilities and organizations:', addPayload);

     this.AppHubV4Service.addcaps(addPayload).subscribe(
        res => {
          if(res) {
            this.toaster.success('Capability added successfully to the application.', '', {
              timeOut: 10000,
              positionClass: 'toast-top-center'
            });
            this.addCapability.emit(addPayload);
          }
        }, err => {
          console.log(err, 'error occured while update');
          this.toaster.error('Internal server error.', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
        });
  }

  onCancel() {
    this.applyPopup.hide();
  }

  get showOpenRequestMessage(): boolean {
    return this._recHasOpenRequest || this._nonRecHasOpenRequest;
  }

  navigateToOpenRequestPage(): void {
    const combined = [...this._recWqList, ...this._nonRecWqList];
    const ids = [...new Set(combined.map((val: any) => val['Request_Id']))];
    const baseUrl = window.location.origin;
    const urlparams = ids.join(',');
    const wqUrl = baseUrl + '/work-queues?req=wq&id=' + JSON.stringify(urlparams);
    window.open(wqUrl, '_blank');
  }
}
